import { useTypedSelector } from '../store/store';

export const useSupplierId = () => {
    const { id } = useTypedSelector((state) => state.account.selectedAccount);

    return {
        supplierId: id,
    };
};
